module.exports = __webpack_public_path__ + "static/img/color.bb7d4e32.jpg";